import { render, staticRenderFns } from "./account-system-settings.vue?vue&type=template&id=3a07eed4&"
import script from "./account-system-settings.vue?vue&type=script&lang=js&"
export * from "./account-system-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports